import { SVGProps } from 'react';

const LeftChevron = ({
  height = '24px',
  width = '24px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    id='LeftChev'
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    {...props}
  >
    <g id='Layer' transform='translate(8.85 6.248)'>
      <g id='Vrstva_129' data-name='Vrstva 129'>
        <path
          id='Path_128'
          data-name='Path 128'
          d='M13.38,17.45a1,1,0,1,0,1.41-1.42L11.3,12.36a.25.25,0,0,1,0-.33L14.9,7.9a1,1,0,1,0-1.51-1.32L9.16,11.43a1.21,1.21,0,0,0,0,1.62Z'
          transform='translate(-8.849 -6.237)'
        />
      </g>
    </g>
  </svg>
);

export default LeftChevron;
